import React from 'react';
import styles from './filter-price-slider.module.css';
import type {FilterPriceSliderProps} from './filter-price-slider.types';
import {useFilterPriceSlider} from './use-filter-price-slider';

export function FilterPriceSlider({
    min,
    max,
    step = 1,
    value,
    onChange,
    disabled = false,
}: Readonly<FilterPriceSliderProps>) {
    const {localMin, localMax, activeTrackStyle, handleMinChange, handleMaxChange} = useFilterPriceSlider({
        min,
        max,
        value,
        onChange,
    });

    return (
        <div className={styles.wrapper}>
            <div className={styles.slider}>
                <div className={styles.track} />
                <div className={styles.activeTrack} style={activeTrackStyle} />

                <input
                    type="range"
                    min={min}
                    max={max}
                    step={step}
                    value={localMin}
                    onChange={handleMinChange}
                    disabled={disabled}
                    className={`${styles.rangeInput} ${styles.rangeInputMin}`}
                    aria-label="Giá tối thiểu"
                />

                <input
                    type="range"
                    min={min}
                    max={max}
                    step={step}
                    value={localMax}
                    onChange={handleMaxChange}
                    disabled={disabled}
                    className={`${styles.rangeInput} ${styles.rangeInputMax}`}
                    aria-label="Giá tối đa"
                />
            </div>
        </div>
    );
}
